import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import styled from "styled-components";

interface IconButtonProps {
  icon: IconDefinition;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  variant?: string;
  active?: boolean;
}

const DefaultButton = styled(Button)`
  padding: 0.5em;
  margin: 0.2rem;
`;

const IconButton = ({
  icon,
  onClick,
  disabled,
  title,
  active,
  variant = "primary",
}: IconButtonProps) => {
  return (
    <DefaultButton
      active={active}
      title={title}
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      className={active? "btn-active" : ""}
    >
      <FontAwesomeIcon icon={icon}></FontAwesomeIcon>
    </DefaultButton>
  );
};

export default IconButton;
